export default __webpack_public_path__ + "static/media/noNotifications.25798765.svg";